<template>
  <div class="ma-2 ml-3 site_content">
    <comboFarm
        @fromFarm="farmInfo"
    />

    <div class="flex mt-3 mb-flex">
      <div class="radio-container">
        <div class="flex">
          <div class="radio-title">산출기준 |</div>
          <div class="radio-group">
            <v-radio-group dense outlined row 
              id="val" 
              ref="val" 
              v-model="val"
            >
              <v-radio label="연간" value="year" color="#005B96" />
              <v-radio label="출하 KG 당" value="kg" color="#005B96"/> 
            </v-radio-group>
          </div>
        </div>

        <div class="grayline"> </div>

        <div class="flex">
          <div class="radio-title mb-text"> 배출량 집계 방식 |</div>
          <div class="radio-group">
            <v-radio-group dense outlined row 
              id="data" 
              ref="data" 
              v-model="data"
            >
              <v-radio label="전체" value="total" color="#005B96"/>
              <v-radio label="배출원별" value="element" color="#005B96"/> 
            </v-radio-group>
          </div>
        </div>
      </div>

      <div>
        <datePicker
          :fr_date="fr_date" 
          :to_date="to_date" 
          @update:fr_date="updateFrDate"
          @update:to_date="updateToDate"
          @refresh="monitoringEsgValueOfFarm" 
        />
        <div class="info-text mt-1">
          * 선택한 기간의 각 월에 대해, 1년 전부터 해당 월까지의 연간 데이터가 각각 산출됩니다.
        </div>
      </div>
    </div>

    <div class="esg-chart-container" >
      <div v-if="loading" class="loading-container">
        <div class="spinner"></div>
      </div>

      <div v-else>
        <Chart
          v-if="this.val == 'year'"
          chartType="Bar"
          :chart-data="chartYearEsg"  
          :chartSize="chartSize" 
          :chart-options="barChartOptions" >
        </Chart>

        <Chart
          v-else
          chartType="Bar"
          :chart-data="emissionPerKgData"  
          :chartSize="chartSize" 
          :chart-options="barChartOptions" >
        </Chart>
      </div>
    </div>

    <div class="table_layout">
      <v-data-table  dense height="450" v-resize="onResize"
          id="time__table"
          fixed-header
          :items-per-page="-1" 
          :footer-props="{
            itemsPerPageOptions:[-1]
          }"
          :headers="headers"
          :items="esgItems"
          no-data-text="측정된 자료가 없습니다."
          item-key="dateYm"
          single-select
          hide-default-header
          hide-default-footer
          :sort-by= "['dateYm']"
          :sort-desc= "[true]"
        >
        <template v-slot:header>
          <thead v-if="!isMobile">
            <tr>
              <th rowspan="2" @click="toggleSort('date')" >날짜</th>
              <th colspan="3" class="text-center group-header">연간</th>
              <th colspan="3" class="text-center group-header">출하 kg당</th>
            </tr>
            <tr>
              <th class="sub-header" style="top:40px !important;">장내발효</th>
              <th class="sub-header" style="top:40px !important;">분뇨처리</th>
              <th class="sub-header" style="top:40px !important;">에너지</th>

              <th class="sub-header" style="top:40px !important;">장내발효</th>
              <th class="sub-header" style="top:40px !important;">분뇨처리</th>
              <th class="sub-header" style="top:40px !important;">에너지</th>
            </tr>
          </thead>
        </template>

        <template v-slot:item= "{ item }">
          <tr v-if="!isMobile" >
            <td style="text-align:center;">{{ item.data.sel_date.from }} ~ {{ item.data.sel_date.to }}</td>

            <td style="text-align:center;">{{ addCommas(item.data.sel.intestinal.ch4.local * 28) }} </td>
            <td style="text-align:center;">{{ addCommas((item.data.sel.excreta.ch4.local*28) + (item.data.sel.excreta.n2o.local*265))}} </td>
            <td style="text-align:center;">{{ addCommas((item.data.sel.energy.ch4.local*28) + (item.data.sel.energy.n2o.local*265) + (item.data.sel.energy.co2.local))}} </td>

            <td style="text-align:center;">{{ (item.data.sel_kg.intestinal.ch4.local * 28).toFixed(2) }} </td>
            <td style="text-align:center;">{{ ((item.data.sel_kg.excreta.ch4.local*28) + (item.data.sel_kg.excreta.n2o.local*265)).toFixed(2)}} </td>
            <td style="text-align:center;">{{ ((item.data.sel_kg.energy.ch4.local*28) + (item.data.sel_kg.energy.n2o.local*265) + (item.data.sel_kg.energy.co2.local)).toFixed(2)}} </td>
          </tr>

          <tr v-else class="mobile_tr">
            <td class="mb_table">
              <div class="date mt-2">
								<div class="flex-title"> 날짜</div>
								<div>{{ item.data.sel_date.from }} ~ {{ item.data.sel_date.to }}</div>
							</div>

              <div class="flex content s-bt">
                <div class="flex-title">연간</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight">장내발효</div>
                    <div> {{ (item.data.sel.intestinal.ch4.local * 28).toFixed(0) }} </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">분뇨처리</div>
                    <div> {{ ((item.data.sel.excreta.ch4.local*28) + (item.data.sel.excreta.n2o.local*265)).toFixed(0)}} </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">에너지</div>
                    <div> {{ ((item.data.sel.energy.ch4.local*28) + (item.data.sel.energy.n2o.local*265) + (item.data.sel.energy.co2.local)).toFixed(0)}}  </div>
                  </div>
                </div>
              </div>

              <div class="flex content s-bt">
                <div class="flex-title">출하 kg 당</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight">장내발효</div>
                    <div>{{ (item.data.sel_kg.intestinal.ch4.local * 28).toFixed(2) }} </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">분뇨처리</div>
                    <div> {{ ((item.data.sel_kg.excreta.ch4.local*28) + (item.data.sel_kg.excreta.n2o.local*265)).toFixed(2)}}  </div>
                  </div>

                  <div class="flex-content">
                    <div class="weight">에너지</div>
                    <div>{{ ((item.data.sel_kg.energy.ch4.local*28) + (item.data.sel_kg.energy.n2o.local*265) + (item.data.sel_kg.energy.co2.local)).toFixed(2)}} </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_month.vue";
import Chart from "@/components/chart/Chart.vue"
import { barChartOptions} from "@/components/chart/option.js";  // 옵션 불러오기


export default ({
  name:"Esg",
  components:{
    comboFarm,
    datePicker,
    Chart
  },
  watch:{
    val(newVal, oldVal) {
        if (newVal !== oldVal) this.EsgChartData();
    },
    data(newVal, oldVal) {
        if (newVal !== oldVal) this.EsgChartData();
    }
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

  },
  data(){
    let cdate = new Date();
    let toDate = dateUtil.format(cdate, "yyyy-MM");

    let frdate = new Date(cdate.setMonth(cdate.getMonth() - 13));
    let frDate = dateUtil.format(frdate, "yyyy-MM");

    return{
      barChartOptions:barChartOptions,
      farmData: { company: {}, farm: {} },
      
      val:'year',
      data:'total',

      fr_date: frDate,
      to_date: toDate,
      
      chartSize: {
        height:'30vh',
        width: '100%',
      },

      esgItems:[],

      chartEsg:{},
      chartYearEsg: {
        labels: [],
        datasets: []
      },
      emissionPerKgData: {
        labels: [],
        datasets: []
      },
      loading:false,
      isMobile: false,

      headers: [
        { text: '날짜', align: 'center', value: 'data.sel_date.from', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: '연간장내', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: '연간분뇨', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: '연간에너지', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: 'kg장내', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: 'kg분뇨', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
        { text: 'kg에너지', align: 'center', value: '', filterable: true, sortable: true, groupable: false, width: "130px", show: true,divider: true},
      
      ],
    }
  },
  methods:{
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
			this.isMobile = false;
    },
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.monitoringEsgValueOfFarm();
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    addCommas(num){
      if (typeof num === 'number') {
          return num.toLocaleString();
      }
      return num;
    },
    async monitoringEsgValueOfFarm(){
      this.loading = true;

      let fromDate = new Date(this.fr_date + '-01');
      let toDate = new Date(this.to_date + '-01');

      let loop = (toDate.getFullYear() - fromDate.getFullYear()) * 12 + (toDate.getMonth() - fromDate.getMonth());


      let lastArray = [];
      let apiDatas = [];

      // console.log(loop)
      for(let i = 0; i <= loop; i++){

        let frDate = new Date(this.fr_date + '-01');
        frDate.setMonth(frDate.getMonth() + i); 
        frDate.setDate(1); 

        let esgDate = dateUtil.format(frDate, "yyyy-MM-dd");
        // console.log(esgDate)

        let apiData = Apis.monitoringEsgValueOfFarm({
          farmNo: this.farmData.farm.no,
          stand_date: esgDate,
          month:12,
        },(res) => {

          // console.log(`API response for ${esgDate}:`, res);
        
          this.$store.commit("resMessage",res.message);

          if (res.result) { lastArray.push({date: esgDate,data: res.data}) }
          // console.log(lastArray)
        }).catch( (err) =>{
          console.log("monitoringEsgValueOfFarm2 API 호출 오류",err)
        });
        apiDatas.push(apiData);
      }

      await Promise.all(apiDatas);

      this.esgItems = lastArray.sort((a, b) => new Date(b.date) -  new Date(a.date));
      // this.esgItems = lastArray;
      // console.log("last", this.esgItems)

      this.EsgChartData();
    },
    EsgChartData(){
      let selDate = [];
      let Energy = [];
      let Intestinal = [];
      let Excreta = [];

      let Total = [];

      let kgEnergy = [];
      let kgIntestinal = [];
      let kgExcreta = [];

      let kgTotal = [];

      // console.log(this.esgItems)

      this.esgItems.forEach(function (item){
        // console.log(item)
        selDate.push(item.data.sel_date.from + ' ~ ' + item.data.sel_date.to)

        let energyCo2 = parseFloat(item.data.sel.energy.co2.local) || 0;
        let energyCh4 = parseFloat(item.data.sel.energy.ch4.local) || 0;
        let energyN2o = parseFloat(item.data.sel.energy.n2o.local) || 0;
        Energy.push(energyCo2 + (energyCh4*28) + (energyN2o*265))
        
        let intestinalCh4 = parseFloat(item.data.sel.intestinal.ch4.local) || 0;
        Intestinal.push(intestinalCh4*28)

        let excretaCh4 = parseFloat(item.data.sel.excreta.ch4.local) || 0;
        let excretaN2o = parseFloat(item.data.sel.excreta.n2o.local) || 0;
        Excreta.push( (excretaCh4*28) + (excretaN2o*265));

        Total.push(energyCo2 + (energyCh4*28) + (energyN2o*265) + (intestinalCh4*28) + (excretaCh4*28) + (excretaN2o*265));

        let kgenergyCo2 = parseFloat(item.data.sel_kg.energy.co2.local) || 0;
        let kgenergyCh4 = parseFloat(item.data.sel_kg.energy.ch4.local) || 0;
        let kgenergyN2o = parseFloat(item.data.sel_kg.energy.n2o.local) || 0;
        kgEnergy.push(kgenergyCo2 + (kgenergyCh4*28) + (kgenergyN2o*265));

        let kgintestinalCh4 = parseFloat(item.data.sel_kg.intestinal.ch4.local) || 0;
        kgIntestinal.push(kgintestinalCh4*28)

        let kgexcretaCh4 = parseFloat(item.data.sel_kg.excreta.ch4.local) || 0;
        let kgexcretaN2o = parseFloat(item.data.sel_kg.excreta.n2o.local) || 0;
        kgExcreta.push( (kgexcretaCh4*28) + (kgexcretaN2o*265) );

        kgTotal.push(kgenergyCo2 + (kgenergyCh4*28) + (kgenergyN2o*265) + (kgintestinalCh4*28) + (kgexcretaCh4*28) + (kgexcretaN2o*265));
      })

      this.chartEsg = {
        selDate : selDate,
        Energy:Energy,
        Intestinal:Intestinal,
        Excreta:Excreta,
        Total : Total,

        kgEnergy:kgEnergy,
        kgIntestinal:kgIntestinal,
        kgExcreta:kgExcreta,
        kgTotal : kgTotal
      }
      // console.log(this.chartEsg )

      this.drawChart();
      this.loading = false;

    },
    drawChart(){
      // console.log(this.chartEsg )
      if(this.val == 'year' && this.data == 'total'){
        this.chartYearEsg = this.YeartotalChart();
      }else if(this.val ==  'year' && this.data == 'element'){
        this.chartYearEsg = this.YeardataChart();
      }else if(this.val ==  'kg' && this.data == 'total'){
        this.emissionPerKgData = this.kgtotalChart();
      }else{
        this.emissionPerKgData = this.kgdataChart();
      }
    },
    YeartotalChart(){
      return{
        labels:this.chartEsg.selDate,
        datasets: [
          {
            label: '전체', 
            barPercentage: 0.3,
            data:this.chartEsg.Total,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)', 
          }
        ]
      }
    },
    YeardataChart(){
      // console.log(this.chartEsg)
      return{
        labels:this.chartEsg.selDate,
        datasets: [
          {
            label: '장내발효', 
            data:this.chartEsg.Intestinal,
            barPercentage: 0.6,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)', 
          },
          {
            label: '분뇨처리', 
            data:this.chartEsg.Excreta,
            barPercentage: 0.6,
            backgroundColor:'rgba(244, 209, 96, 0.6)',
            borderColor: 'rgba(244, 209, 96, 0.6)',
          },
          {
            label: '에너지', 
            data:this.chartEsg.Energy,
            barPercentage: 0.6,
            backgroundColor: 'rgba(131, 180, 255, 0.6)',  
            borderColor: 'rgba(131, 180, 255, 0.6)', 
          },
        ]
      }
    },
    kgtotalChart(){
      return{
        labels:this.chartEsg.selDate,
        datasets: [
          {
            label: '전체', 
            barPercentage: 0.3,
            data:this.chartEsg.kgTotal,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)', 
          }
        ]
      }
    },
    kgdataChart(){
      return{
        labels:this.chartEsg.selDate,
        datasets: [
          {
            label: '장내발효', 
            data:this.chartEsg.kgIntestinal,
            barPercentage: 0.6,
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
            borderColor: 'rgba(90, 114, 160, 0.6)',
          },
          {
            label: '분뇨처리', 
            data:this.chartEsg.kgExcreta,
            barPercentage: 0.6,
            backgroundColor:'rgba(244, 209, 96, 0.6)',
            borderColor: 'rgba(244, 209, 96, 0.6)',
          },
          {
            label: '에너지', 
            data:this.chartEsg.kgEnergy,
            barPercentage: 0.6,
            backgroundColor: 'rgba(131, 180, 255, 0.6)',  
            borderColor: 'rgba(131, 180, 255, 0.6)', 
          },
        ]
      }
    },
  }
})
</script>

<style scoped lang=scss>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';


.radio-container{
  padding:10px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  margin-right:5px;
}
.radio-title{
  min-width:130px;
  text-align: right;
  margin-right:10px;
}
.radio-group{
  height:45px;
  margin-top:-20px !important;
}
.grayline{
  height:1px;
  border:1px solid #E8E8E8;
  margin-top:5px;
  margin-bottom: 5px;
}
.info-text{
  margin-left:10px;
  font-size:11px;
  color:#939393;
  text-align: center;
}
.esg-chart-container{
  padding:20px;
  margin-top: 15px;
  border-radius: 20px;

  background: #FAFBFB;
  border: 1px solid #E9E9E9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.loading-container{
  height:30vh;
}
.table_layout{
  margin-top:20px !important;
  border-radius: 20px !important;
  padding:0 !important;
  // height:40vh;
  // min-height:250px;
}
.v-data-table th {
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
:deep(.v-data-table__wrapper) {
  max-height: 40vh;
  overflow-y: auto;
  display: block;
}

:deep(.v-table thead tr:first-child th) {
  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}


:deep(.v-table thead th.sub-header) {
  position: sticky;
  top: 40px !important; 
  z-index: 19;
  background-color: #005b96;
  color: white;
  height: 40px;
  text-align: center;
}

@media only screen and (max-width: 768px) {
.radio-title{
  min-width:100px !important;
  // text-align: left;
}
.mb-text{
  letter-spacing: -1.25px;
}
.mb-flex{
  justify-content: center;
}
}
</style>